import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { renderToStaticMarkup } from "react-dom/server";
import { LoadingSpinner } from "@churchofjesuschrist/eden-icons";
import { spacing24 } from "@churchofjesuschrist/eden-style-constants";

const ProgressButton = _ref => {
  let {
    progressing,
    children,
    ...props
  } = _ref;
  const buttonRef = useRef(null);
  const [buttonStyle, setButtonStyle] = useState({
    width: "auto",
    height: "auto"
  });
  const [buttonBackground, setButtonBackground] = useState("");
  const fullWidthStyle = {
    width: "100%"
  };
  useEffect(() => {
    if (progressing) {
      const computedStyles = getComputedStyle(buttonRef.current, null);
      const background = computedStyles.getPropertyValue("background");
      const color = computedStyles.getPropertyValue("color");
      setButtonBackground(background);
      setButtonStyle({
        pointerEvents: "none",
        color: "transparent",
        backgroundImage: `url("data:image/svg+xml; utf8, ${encodeURIComponent(renderToStaticMarkup( /*#__PURE__*/React.createElement(LoadingSpinner, {
          color: color
        })))}")`,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: spacing24
      });
    } else {
      setButtonBackground("");
      setButtonStyle({});
    }
  }, [progressing]);
  return /*#__PURE__*/React.createElement("div", props, React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    ref: buttonRef,
    // Disables the button while the progress prop is active
    "aria-disabled": progressing ? "true" : null,
    onClick: progressing ? () => {} : child.props.onClick,
    // Sets the width of the button with a fullWidth prop and also disables the hover background while the progress prop is active
    style: progressing && child.props.fullWidth ? { ...buttonStyle,
      ...fullWidthStyle,
      backgroundColor: buttonBackground
    } : !progressing && child.props.fullWidth ? { ...buttonStyle,
      ...fullWidthStyle
    } : progressing && !child.props.fullWidth ? { ...buttonStyle,
      backgroundColor: buttonBackground
    } : buttonStyle
  })));
};

ProgressButton.propTypes = {
  /** Whether to show the progress indicator in the given button */
  progressing: PropTypes.bool,

  /** A button element */
  children: PropTypes.element.isRequired
};
export default ProgressButton;